// Add your custom JS here.
var $ = jQuery;
import social from "./social";

// jQuery stuff goes in here
$(window).load(function () {

    social.init();

    // Hover Bootstrap Navbar Dropdowns
    $('#main-nav-desktop .dropdown').mouseover(function () {
        if ($('.navbar-toggler').is(':hidden')) {
            $(this).find('.dropdown-toggle').addClass('show').attr('aria-expanded', 'true');
            $(this).addClass('show').find('.dropdown-menu').addClass('show');
        }
    }).mouseout(function () {
        if ($('.navbar-toggler').is(':hidden')) {
            setTimeout(() => {
                if (!$(this).is(':hover')) {
                    $(this).find('.dropdown-toggle').removeClass('show').attr('aria-expanded', 'false');
                    $(this).removeClass('show').find('.dropdown-menu').removeClass('show');
                }
            }, 300);
        }
    });

    // Add Mobile Menu Dropdown Carets
    $('#main-nav-mobile .dropdown > a.dropdown-toggle').append('<span class="dropdown-caret fa fa-angle-down pull-right fs-2 pt-1 position-absolute"></span>')

    // Mobile Tap Navbar Dropdowns to Expand
    $('#main-nav-mobile .dropdown > a.dropdown-toggle > .dropdown-caret').on('click', function (e) {
        if (window.matchMedia("(max-width: 992px)").matches) {
            e.preventDefault();
            $(this).toggleClass('show').attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true'
            });
            $(this).closest('li').find('.dropdown-menu').toggleClass('show');

        }
    });

}); // Window load

// Vanilla JS goes below

// Navbar mobile handler
document.addEventListener('DOMContentLoaded', (event) => {
    const navbarPrimary = document.querySelector('#navbarNavDropdownPrimary');
    const navbarHeader = document.querySelector('#navbarNavDropdownHeader');
    const navbarTogglerPrimary = document.querySelector('#navbarTogglerPrimary');
    const navbarTogglerHeader = document.querySelector('#navbarTogglerHeader');
    const iconPrimary = navbarTogglerPrimary.querySelector('.nav-toggler-icon');
    const iconHeader = navbarTogglerHeader.querySelector('.nav-toggler-icon');

    function toggleIcons() {
        if (iconPrimary.classList.contains('close')) {
            iconPrimary.classList.remove('close');
            iconHeader.classList.remove('close');
        } else {
            iconPrimary.classList.add('close');
            iconHeader.classList.add('close');
        }
    }

    navbarTogglerPrimary.addEventListener('click', function () {
        navbarTogglerHeader.click();
        toggleIcons();
    });

    document.addEventListener('click', function (event) {
        const isClickInsidePrimary = navbarPrimary.contains(event.target);
        const isClickInsideHeader = navbarHeader.contains(event.target);

        if (!isClickInsidePrimary && !isClickInsideHeader && navbarPrimary.classList.contains('show')) {
            navbarTogglerPrimary.click();
        }
    });
});


// Handler for acronym on dropdown nav
window.onload = function () {
    let menuItemsLi = document.querySelectorAll('.make-acronym');

    menuItemsLi.forEach(menuItemLi => {
        let menuItem = menuItemLi.querySelector('a');

        if (menuItem) {
            let words = menuItem.textContent.split(' ');
            let firstFourWords = words.slice(0, 4);
            let remainingWords = words.slice(4);

            let acronym = firstFourWords.map(word => word.substring(0, 1)).join('');
            let newMenuItemText = acronym + ' ' + remainingWords.join(' ');

            menuItem.textContent = newMenuItemText;
        }
    });
}

document.addEventListener('DOMContentLoaded', (event) => {
    // Ensure the videoPlayer and playPauseBtn elements exist before attempting to add event listeners
    let videoPlayer = document.getElementById('videoPlayer');
    let playPauseBtn = document.getElementById('playPauseBtn');

    if (videoPlayer && playPauseBtn) {
        playPauseBtn.addEventListener('click', function () {
            if (this.dataset.state === 'play') {
                videoPlayer.play();
                this.dataset.state = 'pause';
                this.innerHTML = '<i class="fa fa-pause"></i>';
            } else {
                videoPlayer.pause();
                this.dataset.state = 'play';
                this.innerHTML = '<i class="fa fa-play"></i>';
            }
        });
    }
});

document.querySelectorAll('.videoControlBtn').forEach((btn) => {
    // Video controller for homepage hero
    btn.addEventListener('click', function () {
        let video = this.previousElementSibling;
        if (video.paused) {
            video.play();
            this.classList.remove('paused');
            this.querySelector('.visually-hidden').textContent = 'Pause';
            this.setAttribute('aria-label', 'Pause video');
        } else {
            video.pause();
            this.classList.add('paused');
            this.querySelector('.visually-hidden').textContent = 'Play';
            this.setAttribute('aria-label', 'Play video');
        }
    });
});

jQuery(document).ready(function ($) {
    // Slider for application block
    $('.application__btn').on('click', function (e) {
        e.preventDefault();
        $('#applicationForm').slideToggle();
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Handler to add span elements to page
    let textInputs = document.querySelectorAll('.ginput_container_text input[type="text"]');
    let emailInputs = document.querySelectorAll('.ginput_container_email input[type="email"]');
    let telInputs = document.querySelectorAll('.ginput_container_phone input[type="tel"]');
    let inputComplex = document.querySelectorAll('.ginput_complex input[type="text"]')
    let urlInputs = document.querySelectorAll('.ginput_container_website input[type="url"]')

    let inputs = [...textInputs, ...emailInputs, ...telInputs, ...inputComplex, ...urlInputs]; // This combines both lists of inputs

    inputs.forEach(function (input) {
        // Create a new span element
        let span = document.createElement('span');

        // Add 'placeholder' class to the span
        span.className = 'placeholder';

        // Get placeholder text from the input element
        let placeholderText = input.placeholder;

        // Set the span's text to the input's placeholder text
        span.textContent = placeholderText;

        // Remove the placeholder text from the input
        input.placeholder = '';

        // Insert the span before the input in the DOM
        input.parentNode.insertBefore(span, input);

        // Handler for floating class
        input.addEventListener('focus', () => {
            span.classList.add('active');
        });

        input.addEventListener('blur', () => {
            if (input.value === '') {
                span.classList.remove('active');
            }
        });

        if (input.value !== '') {
            span.classList.add('active');
        }
    });
});

$(document).ready(function () {
    let $menuItems = $('.menu-item');

    $menuItems.each(function () {
        let $menuItem = $(this);
        let $dropdownToggle = $menuItem.find('.dropdown-toggle');
        let $dropdownItems = $menuItem.find('.dropdown-item');

        // Add tabindex to allow focus
        $dropdownToggle.attr('tabindex', 0);
        $dropdownItems.attr('tabindex', 0);

        $dropdownToggle.on('keydown', function (e) {
            if (e.key === 'Tab' && !e.shiftKey) {
                e.preventDefault();

                if ($dropdownItems.length > 0) {
                    $dropdownToggle.dropdown('show');
                    $dropdownItems.first().focus();
                } else {
                    moveToNextMenuItem($menuItem);
                }
            } else if (e.key === 'Tab' && e.shiftKey) {
                e.preventDefault();
                moveToPreviousMenuItem($menuItem);
            }
        });

        $dropdownItems.each(function (index) {
            $(this).on('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey) {
                    e.preventDefault();

                    if (index < $dropdownItems.length - 1) {
                        $dropdownItems.eq(index + 1).focus();
                    } else {
                        $dropdownToggle.dropdown('hide');
                        moveToNextMenuItem($menuItem);
                    }
                }
                if (e.key === 'Tab' && e.shiftKey) {
                    e.preventDefault();

                    if (index > 0) {
                        $dropdownItems.eq(index - 1).focus();
                    } else {
                        $dropdownToggle.focus();
                    }
                }
            });
        });
    });

    function moveToNextMenuItem($current) {
        let $next = $current.next('.menu-item');
        let $link = $next.find('.dropdown-toggle, .nav-link').first();

        if ($link.length > 0) {
            $link.focus();
        }
    }

    function moveToPreviousMenuItem($current) {
        let $prev = $current.prev('.menu-item');
        let $link = $prev.find('.dropdown-toggle, .nav-link').first();

        if ($link.length > 0) {
            $link.focus();
        }
    }
});
